import { useEffect, useState } from 'react';

// pass initialValue to withhold the first value until the delay has passed as well,
// instead of returning it straight away on mount
export const useDebouncedValue = <T>(value: T, delay: number, initialValue: T = value) => {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);

  useEffect(() => {
    // debounce set value
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, setDebouncedValue, delay]);

  return debouncedValue;
};
